import cfg from '@/sui/data/sheets/edit/cfg/reaInfADI'
import patient from '@/sui/data/sheets/edit/patient'
import bact from '@/sui/data/sheets/edit/bact'
import intub from '@/sui/data/sheets/edit/intub'
import catheter from '@/sui/data/sheets/edit/catheter'
import bounds from '@/sui/data/sheets/edit/bounds'
import notes from '@/sui/data/sheets/edit/notes'
import fields from '@/sui/data/sheets/edit/fields'

import common from '@/sui/data/sheets/edit/notes/common'

import assert from '@/sui/tools/assert'

function checkKts (result, sheet, explaur) {
  const kts = sheet[fields.catheterArray]
  const ktsNotes = result[fields.catheterArray]
  assert.equals(kts.length, ktsNotes.length)

  const message = `Incohérence entre le champ «Retrait du cathéter»
et le champ «Envoi au laboratoire»`
  const ecmoMessage = `Incohérence entre le champ «ECMO» et les types
de cathéters centraux.`

  const ecmo = sheet[fields.ecmo]
  const ecmoNote = result[fields.ecmo]
  let hasEcmo = false

  for (let i in kts) {
    const kt = kts[i]
    const notes = ktsNotes[i]

    const labo = kt[fields.laboratory]
    const removed = kt[fields.removed]
    if (removed && labo === 3) {
      const laboNote = notes[fields.laboratory]
      const removedNote = notes[fields.removed]
      laboNote.type = removedNote.type = 'error'
      laboNote.tooltip = removedNote.tooltip = message
    }

    const iscol = kt[fields.isColIlcBlc]
    if (iscol != null && iscol !== 0 && iscol !== 9) {
      common.checkMicroOrg(
        notes, kt, fields.isColIlcBlc, 'Une infection', explaur
      )
    }

    const type = kt[fields.catheterType]
    if (type === 'C6') {
      hasEcmo = true
      if (ecmo === 3 || ecmo === 9) {
        const typeNote = notes[fields.catheterType]
        ecmoNote.type = typeNote.type = 'warning'
        ecmoNote.tooltip = typeNote.tooltip = ecmoMessage
      }
    }
  }

  if (!hasEcmo && (ecmo === 1 || ecmo === 2)) {
    ecmoNote.type = 'warning'
    ecmoNote.tooltip = ecmoMessage

    for (let i = 0; i !== ktsNotes.length; ++i) {
      const notes = ktsNotes[i]
      const typeNote = notes[fields.catheterType]
      typeNote.type = 'warning'
      typeNote.tooltip = ecmoMessage
    }
  }
}

function checkBacteremias (result, sheet, explaur) {
  const type = sheet[fields.unitType]
  const neoMixPed = type != null && type.match(/^(NEO|MIX|PED)/) != null

  const bacts = sheet[fields.bactArray]
  const bactsNotes = result[fields.bactArray]
  assert.equals(bacts.length, bactsNotes.length)

  for (let i in bacts) {
    const bactf = bacts[i]
    const notes = bactsNotes[i]
    common.checkBactOrigin(notes, bactf, neoMixPed)
    common.checkBactMicroOrg(notes, bactf, fields.bacteremia, explaur)
  }
}

function checkPneumopathies (result, sheet) {
  const pneumopathies = sheet[fields.pneumopathies]
  const pneumopathiesNotes = result[fields.pneumopathies]
  assert.equals(pneumopathies.length, pneumopathiesNotes.length)

  for (let i in pneumopathies) {
    const pneu = pneumopathies[i]
    const notes = pneumopathiesNotes[i]
    const diagnosis = pneu[fields.diagnosis]

    if (diagnosis != null && diagnosis !== 5) {
      common.checkMicroOrg(notes, pneu, fields.pneumopathy, 'Une pneumopathie')
    }
  }
}

function checkNumericValues (result, sheet) {
  const numericChecks = [
    bounds.igsII,
    bounds.pimII
  ]
  notes.checkNumerics(result, sheet, numericChecks)
}

function checkDates (result, sheet, year) {
  const oldest = notes.oldest[year]
  const newest = notes.newest[year]
  const start = notes.start[year]
  const birthdate = notes.dateField(result, sheet, patient.birthdate)
  const entrydate = notes.dateField(result, sheet, patient.entrydate)
  const deathdate = notes.dateField(result, sheet, patient.deathDate)
  const exitdate = notes.dateField(result, sheet, patient.exitDate)
  const intubdate = notes.dateField(result, sheet, intub.intubStart.std)
  const intubenddate = notes.dateField(result, sheet, intub.intubEnd.std)
  const urinarydate = notes.dateField(result, sheet, cfg.urinaryStart)
  const urinaryenddate = notes.dateField(result, sheet, cfg.urinaryEnd)

  const comparisons = [
    { f: oldest, s: birthdate },
    { f: oldest, s: entrydate },
    { f: oldest, s: exitdate },
    { f: oldest, s: deathdate },
    { f: oldest, s: intubdate },
    { f: oldest, s: intubenddate },
    { f: oldest, s: urinarydate },
    { f: oldest, s: urinaryenddate },

    { f: birthdate, s: newest },
    { f: entrydate, s: newest },
    { f: exitdate, s: newest },
    { f: deathdate, s: newest },
    { f: intubdate, s: newest },
    { f: intubenddate, s: newest },
    { f: urinarydate, s: newest },
    { f: urinaryenddate, s: newest },

    { f: birthdate, s: entrydate },
    { f: birthdate, s: exitdate },
    { f: birthdate, s: deathdate },
    { f: birthdate, s: intubdate },
    { f: birthdate, s: intubenddate },
    { f: birthdate, s: urinarydate },
    { f: birthdate, s: urinaryenddate },

    { f: entrydate, s: deathdate },
    { f: entrydate, s: exitdate },

    { f: intubdate, s: deathdate },
    { f: intubdate, s: exitdate },
    { f: intubdate, s: intubenddate },

    { f: intubenddate, s: deathdate },
    { f: intubenddate, s: exitdate },

    { f: urinarydate, s: deathdate },
    { f: urinarydate, s: exitdate },
    { f: urinarydate, s: urinaryenddate },

    { f: urinaryenddate, s: deathdate },
    { f: urinaryenddate, s: exitdate }
  ]

  const kts = sheet[fields.catheterArray]
  const ktsNotes = result[fields.catheterArray]
  assert.equals(kts.length, ktsNotes.length)

  for (let i in kts) {
    const kt = kts[i]
    const note = ktsNotes[i]
    const insertiondate = notes.dateField(note, kt, catheter.insertionDate)
    const removaldate = notes.dateField(note, kt, catheter.removalDate)
    const coldate = notes.dateField(note, kt, cfg.colIlcBlc)

    if (year >= 2025) {
      common.checkEpisodAndEntry(coldate, entrydate)
    }

    comparisons.push(
      { f: start, s: coldate },
      { f: insertiondate, s: newest },
      { f: removaldate, s: newest },
      { f: coldate, s: newest },

      { f: birthdate, s: insertiondate },
      { f: insertiondate, s: removaldate },
      { f: insertiondate, s: coldate },
      { f: insertiondate, s: deathdate },
      { f: insertiondate, s: exitdate },

      { f: birthdate, s: removaldate },
      { f: entrydate, s: removaldate },
      { f: removaldate, s: deathdate },
      { f: removaldate, s: exitdate },

      { f: birthdate, s: coldate },
      { f: coldate, s: deathdate },
      { f: coldate, s: exitdate }
    )

    if (year >= 2020) {
      const diagdate = notes.dateField(note, kt, bact.diagDate.v1)
      comparisons.push(
        { f: oldest, s: diagdate },
        { f: birthdate, s: diagdate },
        { f: coldate, s: diagdate }
      )
    }

    if (year >= 2021) {
      const manipdate = notes.dateField(note, kt, bact.previousManipDate)
      const beforeEpisod = common.beforeEpisod(
        coldate.date, note[cfg.colIlcBlc.field]
      )

      comparisons.push(
        { f: birthdate, s: manipdate },
        { f: beforeEpisod, s: manipdate },
        { f: manipdate, s: coldate },
        { f: insertiondate, s: manipdate },
        { f: manipdate, s: removaldate },
        { f: manipdate, s: deathdate }
      )
    }
  }

  const bacts = sheet[fields.bactArray]
  const bactsNotes = result[fields.bactArray]
  assert.equals(bacts.length, bactsNotes.length)

  for (let i in bacts) {
    const bactf = bacts[i]
    const note = bactsNotes[i]

    const episoddate = notes.dateField(note, bactf, bact.episod)
    if (year >= 2025) {
      common.checkEpisodAndEntry(episoddate, entrydate)
    }

    const insertiondate = notes.dateField(note, bactf, bact.insertionDate.v1)
    const insertiondate2 = notes.dateField(note, bactf, bact.enfInsertionDate.v1)
    const removaldate = notes.dateField(note, bactf, bact.removalDate.v1)
    comparisons.push(
      { f: start, s: episoddate },
      { f: episoddate, s: newest },
      { f: insertiondate, s: newest },
      { f: insertiondate2, s: newest },
      { f: removaldate, s: newest },

      { f: birthdate, s: episoddate },
      { f: episoddate, s: deathdate },
      { f: episoddate, s: exitdate },

      { f: birthdate, s: insertiondate },
      { f: insertiondate, s: episoddate },
      { f: insertiondate, s: removaldate },
      { f: insertiondate, s: deathdate },
      { f: insertiondate, s: exitdate },

      { f: birthdate, s: insertiondate2 },
      { f: insertiondate2, s: episoddate },
      { f: insertiondate2, s: deathdate },
      { f: insertiondate2, s: exitdate },

      { f: birthdate, s: removaldate },
      { f: entrydate, s: removaldate },
      { f: removaldate, s: deathdate },
      { f: removaldate, s: exitdate }
    )

    if (year >= 2020) {
      const diagdate = notes.dateField(note, bactf, bact.diagDate.v1)
      comparisons.push(
        { f: oldest, s: diagdate },
        { f: birthdate, s: diagdate },
        { f: episoddate, s: diagdate }
      )
    }

    if (year >= 2021) {
      const manipdate = notes.dateField(note, bactf, bact.previousManipDate)
      const enfmanipdate = notes.dateField(
        note, bactf, bact.enfPreviousManipDate
      )
      const beforeEpisod = common.beforeEpisod(
        episoddate.date, note[bact.episod.field]
      )

      comparisons.push(
        { f: birthdate, s: manipdate },
        { f: beforeEpisod, s: manipdate },
        { f: manipdate, s: episoddate },
        { f: insertiondate, s: manipdate },
        { f: manipdate, s: removaldate },
        { f: manipdate, s: deathdate },

        { f: birthdate, s: enfmanipdate },
        { f: beforeEpisod, s: enfmanipdate },
        { f: enfmanipdate, s: episoddate },
        { f: enfmanipdate, s: deathdate },
        { f: insertiondate2, s: enfmanipdate }

      )
    }
  }

  const pneumopathies = sheet[fields.pneumopathies]
  const pneumopathiesNotes = result[fields.pneumopathies]
  assert.equals(pneumopathies.length, pneumopathiesNotes.length)

  for (let i in pneumopathies) {
    const pneu = pneumopathies[i]
    const note = pneumopathiesNotes[i]

    const episoddate = notes.dateField(note, pneu, bact.episod)
    if (year >= 2025) {
      common.checkEpisodAndEntry(episoddate, entrydate)
    }

    comparisons.push(
      { f: start, s: episoddate },
      { f: episoddate, s: newest },
      { f: birthdate, s: episoddate },
      { f: episoddate, s: deathdate },
      { f: episoddate, s: exitdate }
    )

    if (year >= 2020) {
      const diagdate = notes.dateField(note, pneu, bact.diagDate.v1)
      comparisons.push(
        { f: birthdate, s: diagdate },
        { f: episoddate, s: diagdate }
      )
    }
  }
  notes.compareDates(comparisons)
}

function buildNotes (result, sheet, year, surveillance, explaur) {
  checkDates(result, sheet, year)
  checkKts(result, sheet, explaur)
  checkNumericValues(result, sheet)
  checkBacteremias(result, sheet, explaur)
  checkPneumopathies(result, sheet)
  common.checkPatientOrigin(result, sheet, year)
  common.checkPatientBirthdate(result, sheet)
  common.checkUfs(result, sheet, 'reaInfADI', surveillance)
}

export default {
  build2019: function (result, sheet, surveillance) {
    buildNotes(result, sheet, 2019, surveillance)
    return result
  },

  build2020: function (result, sheet, surveillance) {
    buildNotes(result, sheet, 2020, surveillance)
    common.checkPortageMO(result, sheet)
    return result
  },

  build2021: function (result, sheet, surveillance) {
    buildNotes(
      result, sheet, 2021, surveillance,
      common.getExplaurUnit(sheet, surveillance)
    )
    common.checkPortageMO(result, sheet)
    return result
  },

  build2022: function (result, sheet, surveillance) {
    buildNotes(
      result, sheet, 2022, surveillance,
      common.getExplaurUnit(sheet, surveillance)
    )
    common.checkPortageMO(result, sheet)
    return result
  },

  build2023: function (result, sheet, surveillance) {
    buildNotes(
      result, sheet, 2023, surveillance,
      common.getExplaurUnit(sheet, surveillance)
    )
    common.checkPortageMO(result, sheet)
    return result
  },

  build2024: function (result, sheet, surveillance) {
    buildNotes(
      result, sheet, 2024, surveillance,
      common.getExplaurUnit(sheet, surveillance)
    )
    common.checkPortageMO(result, sheet)
    return result
  },

  build2025: function (result, sheet, surveillance) {
    buildNotes(
      result, sheet, 2025, surveillance,
      common.getExplaurUnit(sheet, surveillance)
    )
    common.checkPortageMO(result, sheet)
    return result
  },

  build2026: function (result, sheet, surveillance) {
    buildNotes(
      result, sheet, 2026, surveillance,
      common.getExplaurUnit(sheet, surveillance)
    )
    common.checkPortageMO(result, sheet)
    return result
  }

}
